import React from 'react';
import { TextInputWUT } from '../../../inputs/text-input-wut/text-input-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
import { Widget } from '../../../ui/widget/widget';
export const QuizShortTextWUT = _ref => {
  let {
    id,
    value = '',
    label,
    hideLabel = false,
    disabled = false,
    placeholder,
    onChange,
    onBlur,
    description,
    onFocus,
    error,
    hasError = false,
    errorMessage,
    target,
    required = false,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    media,
    mediaSettings,
    widgetHtml,
    widgetEnabled
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      media: media,
      mediaSettings: mediaSettings
    }),
    renderInput: () => widgetHtml && widgetEnabled ? /*#__PURE__*/React.createElement(Widget, {
      fieldId: id,
      widgetHtml: widgetHtml,
      onChange: onChange,
      value: value
    }) : /*#__PURE__*/React.createElement(TextInputWUT, {
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: disabled,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy,
      hasError: hasError,
      fieldId: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=quiz-short-text-wut.js.map